import moment from 'moment-timezone';

/**
 *
 * @param {date} [date] any date object.
 * @param {string} [format] defaults to 'MM/DD/YY'
 * @param {boolean} [isUTC] whether to format in UTC or not
 * @returns {String} Returns a date string in the MM/DD/YYYY format
 */
export default function momentDateFormat(date, format = 'MM/DD/YY', isUTC = false) {
  if (isUTC) {
    return moment(date).utc().format('YYYY-MM-DD HH:mm:ss');
  }

  return moment(date).format(format);
}

export const formattedDateAndTime = date => {
  return moment(date).format('MM/DD/YY hh:mm A');
};

/**
 *
 * @param {*} date date
 * @param {*} isStart starting date or ending date
 * @returns , formatted timestamp for payload
 */
export const momentTimeStampForPayload = (date, isStart = true) =>
  isStart ? moment(date).startOf('day').utc().format() : moment(date).endOf('day').utc().format();
